import fetch from '@/api/fetch'

/**
 * 获取海报分享图片
 * @param {Object} params - 包含spuId、skuId属性.
 */
export function getPosterInfo(params) {
  return fetch({
    url: '/commodityPoster/getPosterInfo',
    params
  })
}

/**
 * 分享送积分、经验
 * @param {Object} params
 */
export function shareReward(params) {
  return fetch({
    url: '/share/reward',
    unLogin: true,
    params
  })
}

/**
 * 分享卡片接口
 * @param {Object} params
 */
export function sharePosterWx(params) {
  return fetch({
    url: '/commodityPoster/wxMiniQrCode',
    unLogin: true,
    params
  })
}